'use client';

import { AppToaster } from '@/components/ui/toast';
import { UserProvider } from "@/context/UserContext";
import { ReactNode } from 'react';
import { ThemeProvider } from '@/components/providers/ThemeProvider';
import { SidebarProvider } from '@/components/ui/custom-sidebar';
import { SidebarMenuProvider } from '@/components/providers/SidebarMenuProvider';
import { SearchProvider } from '@/context/SearchContext'
import type { SessionUser } from "@/lib/types";

export function Providers({
  children,
  initialUser,
}: {
  children: ReactNode;
  initialUser: SessionUser | null;
}) {

  return (
      <UserProvider initialUser={initialUser}>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <SearchProvider>
            <SidebarProvider>
              <SidebarMenuProvider>
                {children}
              </SidebarMenuProvider>
            </SidebarProvider>
          </SearchProvider>
        </ThemeProvider>
        {/* The app's ONE Toaster. Its position and the toast card's shape are both defined in
            components/ui/toast; nothing else should mount a Toaster. */}
        <AppToaster />
      </UserProvider>
  );
}
